"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.useFormSelector = useFormSelector;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _rcFieldForm = require("rc-field-form");
var _FieldContext = require("rc-field-form/lib/FieldContext");
var _react = require("react");
function useFormSelector(selector, form) {
  var subscribeMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var compare = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Object.is;
  var _useState = (0, _react.useState)(function () {
      return selector(form.getFieldsValue(true));
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var selectorRef = (0, _react.useRef)(selector);
  selectorRef.current = selector;
  var fieldContext = (0, _react.useContext)(_rcFieldForm.FieldContext);
  var formInstance = form || fieldContext;
  // eslint-disable-next-line no-underscore-dangle
  var isValidForm = formInstance && formInstance._init;
  (0, _react.useEffect)(function () {
    // Skip if not exist form instance
    if (!isValidForm) {
      return;
    }
    var getInternalHooks = formInstance.getInternalHooks;
    var _getInternalHooks = getInternalHooks(_FieldContext.HOOK_MARK),
      registerWatch = _getInternalHooks.registerWatch;
    var cancelRegister = registerWatch(function () {
      setValue(function (prevState) {
        var allValues = form.getFieldsValue(true);
        var newState = selectorRef.current(allValues);
        if (compare(prevState, newState)) {
          return prevState;
        }
        if (subscribeMode) return prevState;
        return newState;
      });
    });
    // eslint-disable-next-line consistent-return
    return cancelRegister;
  },
  // We do not need re-register since namePath content is the same
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [isValidForm]);
  return value;
}
var _default = exports["default"] = useFormSelector;